import * as React from 'react';
import { useEffect } from 'react';
import {
  Gpio,
  useGpioDetailQuery,
  useGpioDetailUpdateSubscription,
} from '../../../../types/generated-types';
import BorderedSection from '../../shared/borderedSection';
import DeviceLoadingSkeleton from '../shared-ui/deviceLoadingSkeleton';
import Typography from '@mui/material/Typography';
import { updateCacheFromSubscriptionEvent } from '../../../../helpers/subscriptionUtils';
import './gpio.css';

export const GpioComponent = ({
  deviceId,
  role,
}: {
  deviceId: string;
  role: string;
}) => {
  const [device, setDevice] = React.useState<Partial<Gpio>>();
  const {
    data,
    // TODO: Loading_error: deal with error/loading for GPIO detail query
    // error,
    // loading
  } = useGpioDetailQuery({
    variables: { id: deviceId ?? '' },
  });

  useGpioDetailUpdateSubscription({
    variables: { ids: [deviceId] },
    fetchPolicy: 'no-cache',
    onData: updateCacheFromSubscriptionEvent,
  });

  useEffect(() => {
    if (data?.gPIOById) {
      setDevice(data.gPIOById as Partial<Gpio>);
    }
  }, [data]);

  const isAlarm = role === 'Alarm';
  const isActive = !!device?.state?.value;

  let color: string;
  let borderColor: string;
  let backgroundColor: string;
  let borderWidth = '1px';
  let marginTop = '0px';
  let label: string;
  let paddingTop = '0px';
  if (isAlarm) {
    color = isActive ? 'white' : '#212121';
    backgroundColor = isActive ? 'red' : '#abdfbd';
    label = isActive ? 'Alert' : 'Ok';
    borderColor = isActive ? 'red' : '#2eb05b';
    borderWidth = isActive ? '2px' : '2px';
    marginTop = isActive ? '4px' : '5px';
    paddingTop = isActive ? '4px' : '5px';
  } else {
    color = isActive ? '#2eb05b' : 'gray';
    backgroundColor = 'white';
    color = isActive ? '#2eb05b' : 'gray';
    backgroundColor = 'white';
    label = isActive ? 'On' : 'Off';
    borderColor = isActive ? '#2eb05b' : 'red';
  }

  return device ? (
    <div
      style={{
        flexDirection: 'column',
        justifyContent: 'space-around',
        width: '33%',
      }}
      className="gpio-component"
    >
      <BorderedSection
        error={isAlarm && isActive}
        title={
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '12px',
              color,
            }}
          >
            {device.name ?? `Unnamed ${role}`}
          </Typography>
        }
        style={{
          margin: '4px',
          // justifyContent: 'space-evenly',
          border: '1px solid rgba(0, 0, 0, 0.2)',
          borderRadius: '5px',
          borderWidth,
          backgroundColor,
          borderColor,
          marginTop,
          paddingTop,
        }}
        ccStyle={{ padding: '4px', marginTop: '-8px' }}
      >
        <Typography align="center" sx={{ m: 0, color }} variant="h4">
          {label}
        </Typography>
      </BorderedSection>
    </div>
  ) : (
    <DeviceLoadingSkeleton width={80} sx={{ m: '2px' }} />
  );
};
